import { lazy } from 'react';

const ConfigureCoursePlan = lazy(() =>
  import('./components/ConfigureCoursePlanModal'),
);

export default {
  CONFIGURE_COURSE_PLAN: ConfigureCoursePlan,
};
